import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {AthletesResponseApiModel} from "../models/athletes.response-api-model";

import {AthletesFactory} from "./athletes.factory";
import {AthletesRepository} from "./athletes.repository";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";

export class AthletesDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, AthletesRepository, AthletesFactory, DomainRequestManager];

  populateResponse(athleteResponseApiModel: AthletesResponseApiModel) {
    if (!athleteResponseApiModel) {
      return null;
    }
    return this.factory.createDomainModel(athleteResponseApiModel);
  }
}
